// components/providers/AppProviders.tsx
import React, { ReactNode } from 'react';
import { BrowserRouter } from 'react-router-dom';
import AppPlaceholder from '../components/app-placeholder/AppPlaceholder';
import { ModalProvider } from '../components/modal-context/ModalContext';
import { TranslationProvider } from '../components/translation-provider';
import { AuthProviders } from './AuthProviders';
import { DataProviders } from './DataProviders';
import { SentryProvider } from '@src/hooks/useSentry';
import { SentryErrorBoundary } from '@src/components/SentryErrorBoundary';

interface AppProvidersProps {
  children: ReactNode;
}

export const AppProviders: React.FC<AppProvidersProps> = ({ children }) => {
  return (
    <AuthProviders>
      <AppPlaceholder>
        <BrowserRouter>
          <DataProviders>
            <ModalProvider>
              <TranslationProvider>
                <SentryProvider>
                  <SentryErrorBoundary>
                    {children}
                  </SentryErrorBoundary>
                </SentryProvider>
              </TranslationProvider>
            </ModalProvider>
          </DataProviders>
        </BrowserRouter>
      </AppPlaceholder>
    </AuthProviders>
  );
};